// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import Deveui_UplinkSchema from './deveui-uplink-schema';

const schema = {
  $id: '/post-sensor-log-request-schema',
  type: 'object',
  required: ['requestData'],
  properties: {
    requestData: {
      ...Deveui_UplinkSchema,
    },
  },
} as IJSONSchema;

export default schema;
